import { useQuery } from '@apollo/client';
import { MenuItem, type SelectProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DetailSelect } from '~/components/forms/details';
import { useAppContext } from '~/contexts';
import { ChannelGuideSelectDocument } from './ChannelGuideSelect.generated';

export const ChannelGuideSelect = (props: SelectProps) => {
  const { t } = useTranslation();
  const { currentNetwork } = useAppContext();

  const { data } = useQuery(ChannelGuideSelectDocument, {
    variables: { networkId: currentNetwork.id },
  });

  const channelGuides = data?.network?.allChannelGuides ?? [];

  return (
    <DetailSelect {...props}>
      <MenuItem value={-1}>
        {t('components.channel_guide_select.options.channel_guide_none')}
      </MenuItem>
      {channelGuides.map((channelGuide) => (
        <MenuItem key={channelGuide.id} value={channelGuide.id}>
          {channelGuide.name}
        </MenuItem>
      ))}
    </DetailSelect>
  );
};
